import { useSelector } from 'react-redux';
import styles from './PackageCount.module.less';
import { useDispatchOnMount } from '../../../hooks';
import { fetchPackageSummary } from '../../../redux/packageInventory/actions';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import Tooltip from '../../generic/Tooltip';
import Loader from '../../generic/Loader';

/**
 * Component to show the total package count.
 * On hover, a tooltip displays the last cache date.
 */
const PackageCount = () => {
  useDispatchOnMount(fetchPackageSummary);
  const packageSummary = useSelector(PackageInventoryStore.selectors.getPackageSummary);
  const { count, lastCacheDate } = packageSummary;
  const asyncStatus = useSelector(PackageInventoryStore.selectors.getAsyncStatusGetPackageSummary);
  const packageCountContent = asyncStatus.isLoading ? (
    <div className="margin-top-sm">
      <Loader size={30} />
    </div>
  ) : (
    <div className={styles.count}>{count}</div>
  );

  return (
    <Tooltip id="last-cache-date" tooltip={lastCacheDate}>
      <div className={styles.container}>
        <div className={styles.label}>Packages</div>
        {packageCountContent}
      </div>
    </Tooltip>
  );
};

export default PackageCount;
